module.exports = __webpack_public_path__ + "img/python.fbef321e.svg";